import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cvv: {
      fontFamily: 'caption',
      letterSpacing: 5,
      fontSize: 19,
    },
    paymentError: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      padding: '20px 0',
      color: theme.oysterTheme.ferrari,
      '& .MuiSvgIcon-root': {
        marginRight: 10,
      },
    },
  }),
);

export default useStyles;
